import { PROFILE_TYPES, USER_CODE_STATUS } from '@/utils/enums';

const STORAGE_KEYS = {
    developer: 'feature-modal-dismissed',
    affiliateRules: 'affiliate-rules-modal-dismissed',
};

const AFFILIATE_RULES_CUTOFF = new Date('2026-03-26T00:00:00.000Z');

const state = () => ({
    modals: {
        developer: false,
        affiliateRules: false,
    },
});

const mutations = {
    SHOW_MODAL(state, key) {
        state.modals[key] = true;
    },
    HIDE_MODAL(state, key) {
        state.modals[key] = false;
    },
};

const actions = {
    async checkAndShowModals({ dispatch }) {
        const shown = await dispatch('checkDeveloperModal');
        if (!shown) dispatch('checkAffiliateRulesModal');
    },
    checkDeveloperModal({ commit, rootGetters }) {
        if (localStorage.getItem(STORAGE_KEYS.developer)) return false;

        const userProfiles = rootGetters['profile/userRolesStatus'];
        const hasDeveloperProfile = userProfiles.some(
            (profile) => profile.profile === PROFILE_TYPES.DEVELOPER
                && profile.value === USER_CODE_STATUS.ACTIVE
        );

        if (!hasDeveloperProfile) return false;

        setTimeout(() => {
            commit('SHOW_MODAL', 'developer');
        }, 3000);

        return true;
    },
    checkAffiliateRulesModal({ commit, rootState }) {
        if (localStorage.getItem(STORAGE_KEYS.affiliateRules)) return;

        const affiliateCode = rootState.profile.userCodes?.affiliate;
        const isActiveAffiliate = affiliateCode?.status === USER_CODE_STATUS.ACTIVE;
        const isExistingAffiliate = affiliateCode?.created_at && new Date(affiliateCode.created_at) < AFFILIATE_RULES_CUTOFF;

        if (!isActiveAffiliate || !isExistingAffiliate) return;

        setTimeout(() => {
            commit('SHOW_MODAL', 'affiliateRules');
        }, 3000);
    },
    hideModal({ commit }, key) {
        commit('HIDE_MODAL', key);
        localStorage.setItem(STORAGE_KEYS[key], 'true');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
